import React from 'react';

const RefundPolicy = () => {
  return (
    <div style={{ padding: '3rem 1.5rem', maxWidth: '800px', margin: '0 auto', fontFamily: 'Inter, sans-serif', color: '#334155', lineHeight: '1.7' }}>
      <h1 style={{ color: '#0b2545', borderBottom: '1px solid #ddd', paddingBottom: '1rem' }}>Refund & Cancellation Policy</h1>
      
      <h3>1. Cancellations</h3>
      <p>To cancel or reschedule a booked session, you must contact us at <strong>support@abhikalpconsulting.com</strong> or call us at least <strong>24 hours</strong> before the scheduled time.</p>
      <p>Cancellations made with more than 24 hours' notice are eligible for a full refund or free rescheduling.</p>

      <h3>2. Refunds</h3>
      <p>Refunds are processed in the following cases:</p>
      <ul>
        <li>Double payment due to technical error.</li>
        <li>Service cancellation by Abhikalp due to unavailability.</li>
        <li>Client cancellation with valid 24-hour notice.</li>
      </ul>

      <h3>3. Processing Time</h3>
      <p>Approved refunds will be credited back to the original payment method within <strong>5-7 working days</strong>.</p>
    </div>
  );
};

export default RefundPolicy;